import React from "react";
import { Link } from "react-router-dom";
import { PLAY_STORE_URL } from "../constants/links";
import { FUWALO_LOGO_PATH } from "../constants/branding";

export function ArticleLayout(props: { children: React.ReactNode }) {
  return (
    <div className="page">
      <header className="header">
        <div className="header-inner">
          <Link to="/" className="brand" style={{ textDecoration: "none", color: "inherit" }}>
            <div className="brand-mark brand-mark--logo" aria-hidden="true">
              <img src={FUWALO_LOGO_PATH} alt="" width={32} height={32} />
            </div>
            <span className="brand-name">fuwalo</span>
          </Link>

          <div className="header-actions">
            <a
              className="btn-primary"
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
              aria-label="Download Fuwalo on Google Play"
            >
              Get on Google Play
            </a>
          </div>
        </div>
      </header>

      <main className="article-main">{props.children}</main>

      <footer className="footer">
        <div className="shell">
          <span className="footer-text">
            <Link to="/" style={{ color: "inherit", textDecoration: "none" }}>
              fuwalo
            </Link>{" "}
            — multiplayer piano app
          </span>
        </div>
      </footer>
    </div>
  );
}

